/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import Page, {page} from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalali'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import ProductReportComponent from '../BaseComponent/productReportComponent'
import ProductReportPrint from '../BaseComponent/productReportPrint'
import Loader from '../loaders/loader'

class ProductDriver extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
      printInfo: [],
      finalDate: '',
      aggregation: {}
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var {personId, planDateMin, planDateMax, dayPartId} = this.props.match.params

    sessionStorage.setItem(
      'params',
      `dayPartId=${dayPartId}&driverId=${personId}&planDateMin=${planDateMin}&planDateMax=${planDateMax}&sortBy=providerId_desc`
    )
    sessionStorage.setItem('dispatchId', `driverId=${personId}&planDateMin=${planDateMin}&planDateMax=${planDateMax}`)
    this.setState({
      loading: true
    })
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDRIVER
        }?export=false&pageSize=10&pageNumber=1&dayPartId=${dayPartId}&driverId=${personId}&planDateMin=${planDateMin}&planDateMax=${planDateMax}&sortBy=providerId_desc`,
        {}
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            products: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            finalDate: jMoment(Number(this.convertDigit(planDateMin))).format('jYYYY/jMM/jDD'),
            aggregation: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      products: data
    })
  }

  changeDropDown(data) {
    this.setState({
      products: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDRIVER}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
        } else {
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDRIVER
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['discount'] = excelReport[i]['discountAmount'] + excelReport[i]['extraDiscountAmount']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    let urlParams = sessionStorage.getItem('params')
    let {personId, planDateMin, planDateMax, dayPartId} = this.props.match.params

    let excelColumns = [
      {title: 'نام محصول', value: 'productName'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام تامین کننده', value: 'providerName'},
      {title: 'تعداد', value: 'productCount'}
    ]
    const {name} = this.props.match.params
    sessionStorage.setItem('driverName', name)

    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <ProductReportPrint
          printInfo={this.state.printInfo}
          centerTitle={'گزارش کالا های رساننده'}
          aggregation={this.state.aggregation}
          centerSectionPrint={'کالا های رساننده : ' + name}
          rightSectionPrint={'در تاریخ : ' + this.state.finalDate}
        />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش کالا های رساننده ' + name + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="300px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'کد محصول'}
                width="150px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                width="130px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productQuantityCount'}
                field={'productQuantityCount'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productQuantityValue'}
                field={'productQuantityValue'}
                title={'مقدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productUnitTitle'}
                field={'productUnitTitle'}
                title={'واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'deliveryCount'}
                field={'deliveryCount'}
                title={'تعداد پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'totalAmount'}
                field={'totalAmount'}
                title={'قیمت کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'discount'}
                field={'discount'}
                title={'تخفیف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>{'کالا های رساننده'}</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url="report/dispatch/product/byDriver"
                  showRow={false}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDRIVER + '?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>

                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="detailsInfoTable">
              <ul>
                <li>کالاهای رساننده : {name}</li>
                <li>در تاریخ : {this.state.finalDate}</li>
              </ul>
            </div>

            <ProductReportComponent
              products={this.state.products}
              aggregation={this.state.aggregation}
              personId={personId}
              planDateMin={planDateMin}
              planDateMax={planDateMax}
              dayPartId={dayPartId}
              productFrom="driver"
            />
            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDRIVER}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductDriver
